import PEPRepresentativeTableContainer from './PEPRepresentativeTableContainer';

export default PEPRepresentativeTableContainer;